import { render, staticRenderFns } from "./company-jput.vue?vue&type=template&id=a4e777b0&scoped=true&"
import script from "./company-jput.vue?vue&type=script&lang=js&"
export * from "./company-jput.vue?vue&type=script&lang=js&"
import style0 from "./company-jput.vue?vue&type=style&index=0&id=a4e777b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e777b0",
  null
  
)

export default component.exports